/* NYTRON cart drawer — slide-in side cart with AJAX add/change/remove.
   Pairs with sections/nytron-cart-drawer.liquid + snippets/nytron-cart-contents.liquid + sections/nytron-header.liquid
   build 2026-09-28-one-request-adds — bump this marker when a change must beat Shopify's asset CDN, which
   dedupes and will keep serving the previous bytes under an unchanged ?v= hash. */

(function () {
  'use strict';

  var ROUTES = (window.routes && window.routes.cart_add_url) ? window.routes : {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart'
  };

  var drawer = document.querySelector('[data-nt-cart]');
  if (!drawer) return;

  var body = drawer.querySelector('[data-nt-cart-body]');
  var foot = drawer.querySelector('[data-nt-cart-foot]');
  var subtotalEl = drawer.querySelector('[data-nt-subtotal]');
  var totalsEl = drawer.querySelector('[data-nt-cart-totals]');
  var headerCount = drawer.querySelector('[data-nt-cart-count-text]');
  /* The config <script> is a SIBLING of [data-nt-cart] inside the section wrapper,
     not a child of it, so the drawer-scoped lookup alone always returned null and
     every setting below silently fell back to its hardcoded default. Keep the
     drawer-scoped lookup first in case a future layout nests it. */
  var configEl = drawer.querySelector('[data-nt-cart-config]') ||
                 document.querySelector('[data-nt-cart-config]');
  var config = {};
  try { config = configEl ? JSON.parse(configEl.textContent) : {}; } catch (e) { config = {}; }

  /* ---------- Free gift ($0 product attached to every non-empty cart) ----------
     GIFT_ID is a variant id as a Number; /cart.js returns variant ids as Numbers too,
     so compare loosely-typed values through Number() rather than ===. */
  var GIFT = config.free_gift || null;
  var GIFT_ID = GIFT && GIFT.id ? Number(GIFT.id) : 0;

  function isGiftItem(item) {
    if (!GIFT_ID || !item) return false;
    return Number(item.variant_id || item.id) === GIFT_ID;
  }

  /* A gift-only cart must never look checkout-ready while its cleanup request runs. */
  function hasCheckoutItems(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (!isGiftItem(items[i])) return true;
    }
    return false;
  }

  /* The product page tick box is the customer's opt-out. Pages without one (hero,
     final CTA, sticky bar) attach the gift by default, so every route into the cart
     behaves the same unless the customer has actively said no. */
  function giftWanted() {
    if (!GIFT_ID) return false;
    var cb = document.querySelector('[data-nt-warranty-checkbox]');
    return cb ? !!cb.checked : true;
  }

  /* ---------- Bonus gifts (follow the KIT, not every cart) ----------
     config.bonus_gifts = { trigger_id, items: [{id}] }. The lines are real products whose
     $0 price comes from the automatic Buy-X-get-Y discounts in admin; this module only adds
     them when the kit is in the cart, mirrors the kit quantity, and removes them with it. */
  var BONUS = config.bonus_gifts || null;
  var BONUS_TRIGGER = BONUS && BONUS.trigger_id ? Number(BONUS.trigger_id) : 0;
  var BONUS_IDS = [];
  if (BONUS_TRIGGER && BONUS && BONUS.items) {
    BONUS_IDS = BONUS.items.map(function (x) { return Number(x && x.id); }).filter(Boolean);
  }

  /* ---------- Pre-order (2026-10-27) ----------
     config.preorder = { id, label } only while the kit is at 0 stock and continues selling.
     The kit then goes in with the line property "Pre-order: Ships by <date>", which Shopify
     shows under the item in the cart, at checkout and on the order. */
  var PREORDER = config.preorder || null;
  var PO_ID = PREORDER && PREORDER.id ? Number(PREORDER.id) : 0;
  /* First batch (2026-10-30): config.preorder.first = { id, label } while the hidden reservation
     product has stock. Chosen in the buy box (window.NT_PO_TIER = 'first'), the kit goes in with
     the first-batch date and the reservation line follows the first-batch kits like a gift does. */
  var PO_FIRST = PREORDER && PREORDER.first && PREORDER.first.id ? PREORDER.first : null;
  var PO_ADDON = PO_FIRST ? Number(PO_FIRST.id) : 0;
  function firstChosen() { return !!(PO_FIRST && window.NT_PO_TIER === 'first'); }
  function poLabel() { return firstChosen() ? PO_FIRST.label : PREORDER.label; }
  function withPreorder(item) {
    if (PO_ID && item && Number(item.id) === PO_ID) item.properties = { 'Pre-order': poLabel() };
    return item;
  }
  function isAddonItem(item) {
    return !!(PO_ADDON && item && Number(item.variant_id || item.id) === PO_ADDON);
  }
  /* First-batch kits in the cart; with key/quantity, as if that line were already changed. */
  function firstKitQty(cart, key, quantity) {
    var items = (cart && cart.items) || [], total = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!PO_FIRST || Number(it.variant_id || it.id) !== PO_ID || !it.properties || it.properties['Pre-order'] !== PO_FIRST.label) continue;
      total += it.key === key ? quantity : (it.quantity || 0);
    }
    return total;
  }

  /* The configured gifts are dedicated hidden $0 twin products that exist ONLY as gifts
     (like the warranty), so id alone identifies them. The paid versions are different
     products and are never touched by this lifecycle. */
  function isBonusItem(item) {
    if (!BONUS_IDS.length || !item) return false;
    return BONUS_IDS.indexOf(Number(item.variant_id || item.id)) > -1;
  }
  /* The drawer config entry for a bonus line (id, value_formatted, value_cents), or null. */
  function bonusInfo(item) {
    if (!BONUS || !BONUS.items || !item) return null;
    var vid = Number(item.variant_id || item.id);
    for (var i = 0; i < BONUS.items.length; i++) { if (Number(BONUS.items[i].id) === vid) return BONUS.items[i]; }
    return null;
  }
  function bonusLine(cart, id) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].variant_id || items[i].id) === Number(id)) return items[i];
    }
    return null;
  }
  function kitQty(cart) {
    var items = (cart && cart.items) || [];
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].variant_id || items[i].id) === BONUS_TRIGGER) total += items[i].quantity || 0;
    }
    return total;
  }

  /* ---------- Money formatter ---------- */
  /* Presentment vs shop currency: in a converted market (Shopify Markets shows AUD/EUR/...)
     shop.money_format is the wrong template — wrong symbol, wrong grouping — so format with
     the browser's own rules for the cart's currency instead. */
  var CUR = config.currency || 'USD';
  var SHOP_CUR = config.shop_currency || 'USD';
  var CUR_MISMATCH = CUR !== SHOP_CUR;

  function fxRate() {
    /* Shop-currency amounts (the shipping threshold setting) must be converted into the
       presentment currency before comparing against cart totals. */
    if (!CUR_MISMATCH) return 1;
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      if (r > 0) return r;
    } catch (e) {}
    return 0; /* unknown rate: callers must not guess */
  }

  function formatMoney(cents) {
    /* Whole amounts drop the decimals ($249, not $249.00) — mirrors the Liquid
       money_without_trailing_zeros used across the theme. */
    var whole = cents % 100 === 0;
    if (CUR_MISMATCH) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR, currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2 }).format(cents / 100);
      } catch (e) {}
    }
    var fmt = config.money_format || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (whole) withCommas = amountNoDecimals;
    var commaSep = whole ? amountNoDecimals.replace(/,/g, '.') : amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaSep)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals.replace(/,/g, '.'));
  }

  /* The cart total carries the ISO code only for $-sharing currencies (AUD/CAD/NZD...) — the
     $ is ambiguous against USD, € and £ are not. Mirrors the Liquid render in the drawer. */
  var CUR_LABELED = false;
  if (CUR !== 'USD') {
    try {
      CUR_LABELED = new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR, currencyDisplay: 'narrowSymbol' }).format(0).indexOf('$') > -1;
    } catch (e) {}
  }
  function formatMoneyTotal(cents) {
    var s = formatMoney(cents);
    return CUR_LABELED ? s + ' ' + CUR : s;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- Open / close ---------- */
  var lastFocus = null;

  function openDrawer() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nt-cart-open');
    var panel = drawer.querySelector('.nt-cart__panel');
    if (panel) {
      setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nt-cart-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nt-cart-open]');
    if (trigger) { e.preventDefault(); openDrawer(); return; }
    var closer = e.target.closest('[data-nt-cart-close]');
    if (closer && drawer.contains(closer)) {
      e.preventDefault(); closeDrawer(); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ---------- Render helpers ---------- */
  function renderEmpty() {
    return [
      '<div class="nt-cart__empty">',
      '<svg class="nt-cart__empty-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">',
      '<path d="M4 6h16l-1.5 12.5a1 1 0 0 1-1 .9H6.5a1 1 0 0 1-1-.9L4 6z" stroke="currentColor" stroke-width="1.4"/>',
      '<path d="M8 6V4a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.4"/>',
      '</svg>',
      '<p class="nt-cart__empty-title">Your cart is empty</p>',
      '<p class="nt-cart__empty-sub">Add a kit to get started.</p>',
      '<a href="/collections/all" class="nt-cart__empty-cta" data-nt-cart-close>Continue shopping</a>',
      '</div>'
    ].join('');
  }

  /* Pick the larger of: original_line_price (Shopify discount-aware) and
     variant.compare_at_price × qty (MSRP). Either >, both, or neither may apply. */
  function wasLinePrice(item) {
    var was = item.original_line_price || 0;
    var compare = item.variant && item.variant.compare_at_price ? item.variant.compare_at_price : 0;
    /* /cart.js sometimes uses item.compare_at_price directly */
    if (!compare && item.compare_at_price) compare = item.compare_at_price;
    var price = item.variant && item.variant.price ? item.variant.price : item.price;
    if (compare && price && compare > price) {
      var compareLine = compare * (item.quantity || 1);
      if (compareLine > was) was = compareLine;
    }
    return was;
  }

  function renderLineItem(item, index) {
    var hasDefaultVariant = item.variant_title == null || item.variant_title === '';
    var gift = isGiftItem(item);
    /* Bonus gifts (balaclava, fit map, earplugs, keychain) render exactly like the warranty gift:
       note + FREE, no stepper, no sale badge. Mirrors is_gift in nytron-cart-contents.liquid. */
    var bonus = !gift && isBonusItem(item);
    var giftLike = gift || bonus;
    /* The first-batch reservation follows its kits: no stepper, no remove, a real price. */
    var addon = isAddonItem(item);
    var was = wasLinePrice(item);
    var wasPriceHtml = '';
    if (was > item.final_line_price) {
      wasPriceHtml = '<span class="nt-cart__price-was">' + formatMoney(was) + '</span>';
    }
    /* /cart.js line items carry no compare_at_price, so the gift's $97 anchor would
       survive the Liquid first paint and then vanish on the first JS re-render. Take
       it from the section config instead, which reads it off the variant. */
    if (gift && GIFT.value_formatted) {
      wasPriceHtml = '<span class="nt-cart__price-was">' + escapeHtml(GIFT.value_formatted) + '</span>';
    }
    var binfo = bonus ? bonusInfo(item) : null;
    if (binfo && binfo.value_formatted) {
      wasPriceHtml = '<span class="nt-cart__price-was">' + escapeHtml(binfo.value_formatted) + '</span>';
    }
    /* Badges: sale markdown (compare_at) + one per Shopify discount, each with the
       real code/title and amount. Mirrors snippets/nytron-cart-contents.liquid. */
    var TAG_ICON = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2h5.5L14 8.5 8.5 14 2 7.5V2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="5.5" cy="5.5" r="1" fill="currentColor"/></svg>';
    var discountsHtml = '';
    var compare = (item.variant && item.variant.compare_at_price) || item.compare_at_price || 0;
    var unitPrice = (item.variant && item.variant.price) || item.price || 0;
    /* The gift's compare-at is a value anchor, not a markdown, so it gets no sale badge. */
    if (!giftLike && config.show_sale_badge !== false && compare && unitPrice && compare > unitPrice) {
      var saleSaving = (compare - unitPrice) * (item.quantity || 1);
      discountsHtml += '<span class="nt-cart__discount">' + TAG_ICON + escapeHtml(config.sale_badge_label || 'Sale') + ' −' + formatMoney(saleSaving) + '</span>';
    }
    if (!giftLike && item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      for (var i = 0; i < item.line_level_discount_allocations.length; i++) {
        var d = item.line_level_discount_allocations[i];
        if (d.discount_application && d.discount_application.title) {
          var amt = typeof d.amount === 'number' ? ' −' + formatMoney(d.amount) : '';
          discountsHtml += '<span class="nt-cart__discount">' + TAG_ICON + escapeHtml(d.discount_application.title) + amt + '</span>';
        }
      }
    }
    var imgHtml = item.image
      ? '<img src="' + escapeHtml(item.image.replace(/(\?|&)width=\d+/g, '') + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=200') + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">'
      : '';
    /* Gift line: a note + "× N" (quantity mirrors the kit automatically) + a remove
       button, and the free label instead of $0.00. Mirrors the is_gift branch of
       nytron-cart-contents.liquid. */
    var controlsHtml = addon
      ? '<div class="nt-cart__row"><span class="nt-cart__gift-note">' + escapeHtml(PO_FIRST.label) + '</span>' +
        (item.quantity > 1 ? '<span class="nt-cart__gift-qty">× ' + item.quantity + '</span>' : '') + '</div>'
      : giftLike
      ? [
          '<div class="nt-cart__row">',
          '<span class="nt-cart__gift-note">' + escapeHtml(GIFT.note || 'Included with your kit') + '</span>',
          (item.quantity > 1 ? '<span class="nt-cart__gift-qty">× ' + item.quantity + '</span>' : ''),
          '<button type="button" class="nt-cart__remove" data-nt-remove aria-label="Remove item">',
          '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">',
          '<path d="M3 4h10M6 4V2.5h4V4M5 4l.5 9a1 1 0 0 0 1 .9h3a1 1 0 0 0 1-.9L11 4" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
          '</svg>',
          '</button>',
          '</div>'
        ].join('')
      : [
          '<div class="nt-cart__row">',
          '<div class="nt-cart__qty" role="group" aria-label="Quantity">',
          '<button type="button" data-nt-qty-dec aria-label="Decrease">−</button>',
          '<span class="nt-cart__qty-val" data-nt-qty-val>' + item.quantity + '</span>',
          '<button type="button" data-nt-qty-inc aria-label="Increase">+</button>',
          '</div>',
          '<button type="button" class="nt-cart__remove" data-nt-remove aria-label="Remove item">',
          '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">',
          '<path d="M3 4h10M6 4V2.5h4V4M5 4l.5 9a1 1 0 0 0 1 .9h3a1 1 0 0 0 1-.9L11 4" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
          '</svg>',
          '</button>',
          '</div>'
        ].join('');
    var priceHtml = giftLike
      ? '<span class="nt-cart__price-free">' + escapeHtml(GIFT.free_label || 'FREE') + '</span>'
      : formatMoney(item.final_line_price);

    /* Gift and bonus lines are hidden $0 products whose own pages are not customer pages — no link.
       Keep in sync with the is_gift branch in snippets/nytron-cart-contents.liquid. */
    var linked = !(gift || isBonusItem(item) || addon);
    return [
      '<li class="nt-cart__item' + (giftLike ? ' nt-cart__item--gift' : '') + '" data-nt-line="' + index + '" data-nt-line-key="' + escapeHtml(item.key) + '">',
      linked
        ? '<a href="' + escapeHtml(item.url) + '" class="nt-cart__thumb" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>'
        : '<span class="nt-cart__thumb" aria-hidden="true">' + imgHtml + '</span>',
      '<div class="nt-cart__meta">',
      linked
        ? '<a href="' + escapeHtml(item.url) + '" class="nt-cart__name">' + escapeHtml(item.product_title) + '</a>'
        : '<span class="nt-cart__name">' + escapeHtml(item.product_title) + '</span>',
      hasDefaultVariant ? '' : '<span class="nt-cart__variant">' + escapeHtml(item.variant_title) + '</span>',
      controlsHtml,
      '</div>',
      '<div class="nt-cart__price">',
      wasPriceHtml,
      priceHtml,
      '</div>',
      discountsHtml ? '<div class="nt-cart__badges">' + discountsHtml + '</div>' : '',
      '</li>'
    ].join('');
  }

  function renderUpsells(cartVariantIds) {
    if (!config.upsells || !config.upsells.length) return '';
    var visible = [];
    for (var i = 0; i < config.upsells.length; i++) {
      var u = config.upsells[i];
      if (cartVariantIds.indexOf(u.id) === -1) visible.push(u);
    }
    if (!visible.length) return '';
    var html = '<div class="nt-cart__upsells"><p class="nt-cart__upsells-title">' + escapeHtml(config.upsells_title || 'You might also need') + '</p>';
    for (var j = 0; j < visible.length; j++) {
      var up = visible[j];
      html += '<div class="nt-cart__upsell" data-nt-upsell-id="' + up.id + '">';
      html += '<a href="' + escapeHtml(up.url) + '" class="nt-cart__upsell-thumb" tabindex="-1" aria-hidden="true">';
      if (up.image) html += '<img src="' + escapeHtml(up.image) + '" alt="" width="56" height="56" loading="lazy">';
      html += '</a>';
      html += '<div class="nt-cart__upsell-meta"><p class="nt-cart__upsell-name">' + escapeHtml(up.title) + '</p>';
      html += '<span class="nt-cart__upsell-price">' + escapeHtml(up.price_formatted) + '</span></div>';
      html += '<button type="button" class="nt-cart__upsell-add" data-nt-upsell-add="' + up.id + '"' + (up.available ? '' : ' disabled') + '>' + (up.available ? 'Add' : 'Sold out') + '</button>';
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  function rebuildBody(cart) {
    if (!body) return;
    if (!hasCheckoutItems(cart)) {
      body.innerHTML = renderEmpty();
      return;
    }
    var itemsHtml = '<ul class="nt-cart__items" data-nt-cart-items>';
    var variantIds = [];
    for (var i = 0; i < cart.items.length; i++) {
      itemsHtml += renderLineItem(cart.items[i], i + 1);
      variantIds.push(cart.items[i].variant_id || cart.items[i].id);
    }
    itemsHtml += '</ul>';
    body.innerHTML = itemsHtml + renderUpsells(variantIds);
  }

  function rebuildFoot(cart) {
    if (!foot) return;
    var shipBar = drawer.querySelector('[data-nt-cart-ship]');
    if (!hasCheckoutItems(cart)) {
      foot.setAttribute('hidden', '');
      if (shipBar) shipBar.setAttribute('hidden', '');
      return;
    }
    foot.removeAttribute('hidden');

    /* Re-query rather than using the boot-time references. refreshFromSectionHtml
       replaces foot.innerHTML, which detaches every descendant captured at boot, so
       the cached nodes would still be written to while the visible footer stayed
       frozen on whatever it last showed (including an empty cart's $0.00). */
    var totalsNode = foot.querySelector('[data-nt-cart-totals]') || totalsEl;
    var subtotalNode = foot.querySelector('[data-nt-subtotal]') || subtotalEl;

    /* Rebuild totals block. Savings = max(MSRP-based was-total, Shopify-discount was-total) − final total.
       Captures both compare_at_price markdowns AND Shopify automatic discounts in one number. */
    if (totalsNode) {
      var wasTotal = 0;
      for (var ii = 0; ii < cart.items.length; ii++) {
        wasTotal += wasLinePrice(cart.items[ii]);
      }
      /* /cart.js carries no compare_at_price, so this JS path cannot see the gift's
         $97 (or the kit's MSRP) and would understate the saving. It is a fallback
         only: every normal update re-renders the section server-side, where Liquid
         can read compare_at. Add the gift's value back so the two agree if we ever
         land here. */
      if (GIFT_ID && GIFT.value_cents) {
        for (var gi = 0; gi < cart.items.length; gi++) {
          if (isGiftItem(cart.items[gi])) { wasTotal += Number(GIFT.value_cents); break; }
        }
      }
      /* Same for the bonus gift lines: their compare-at is the value anchor Liquid counts. */
      for (var bi = 0; bi < cart.items.length; bi++) {
        var bvi = bonusInfo(cart.items[bi]);
        if (bvi && bvi.value_cents) wasTotal += Number(bvi.value_cents) * (cart.items[bi].quantity || 1);
      }
      var savings = Math.max(0, wasTotal - cart.total_price);
      var html = '';
      /* Order-level discount codes (whole-cart codes, e.g. email welcome codes) */
      var cartApps = cart.cart_level_discount_applications || [];
      var TAG_ICON_T = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2h5.5L14 8.5 8.5 14 2 7.5V2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="5.5" cy="5.5" r="1" fill="currentColor"/></svg>';
      for (var ai = 0; ai < cartApps.length; ai++) {
        var app = cartApps[ai];
        if (app.target_type === 'shipping_line') continue;
        html += '<div class="nt-cart__totals-row">';
        html += '<span class="nt-cart__discount nt-cart__discount--totals">' + TAG_ICON_T + escapeHtml(app.title || 'Discount') + '</span>';
        html += '<span class="nt-cart__totals-val nt-cart__totals-val--save">−' + formatMoney(app.total_allocated_amount || 0) + '</span>';
        html += '</div>';
      }
      if (savings > 0) {
        html += '<div class="nt-cart__totals-row nt-cart__totals-row--minor">';
        html += '<span class="nt-cart__totals-label">Original</span>';
        html += '<span class="nt-cart__totals-val nt-cart__totals-val--was">' + formatMoney(wasTotal) + '</span>';
        html += '</div>';
        html += '<div class="nt-cart__totals-row nt-cart__totals-row--save">';
        html += '<span class="nt-cart__totals-label nt-cart__totals-label--save">You saved</span>';
        html += '<span class="nt-cart__totals-val nt-cart__totals-val--save">' + formatMoney(savings) + '</span>';
        html += '</div>';
      }
      html += '<div class="nt-cart__subtotal-row">';
      html += '<span class="nt-cart__subtotal-label">Total</span>';
      html += '<span class="nt-cart__subtotal-val" data-nt-subtotal>' + formatMoneyTotal(cart.total_price) + '</span>';
      html += '</div>';
      totalsNode.innerHTML = html;
    } else if (subtotalNode) {
      subtotalNode.textContent = formatMoneyTotal(cart.total_price);
    }

    var checkoutPrice = foot.querySelector('[data-nt-checkout-price]');
    if (checkoutPrice) checkoutPrice.textContent = formatMoney(cart.total_price);

    updateShipBar(cart);
  }

  /* Free-shipping progress bar. The threshold setting is in SHOP currency (USD) while
     cart.total_price is in the visitor's presentment currency, so the threshold is
     converted through Shopify.currency.rate before any comparison. In converted markets
     the section's Liquid renders the bar hidden and this is the only thing that shows it. */
  function updateShipBar(cart) {
    var note = drawer.querySelector('[data-nt-shipping-note]');
    if (!note || !cart) return;
    if (!hasCheckoutItems(cart)) { note.setAttribute('hidden', ''); return; }
    /* The note is now a progress-bar container: update the label + fill width,
       falling back to textContent if the old flat markup is ever served. */
    var shipLabel = note.querySelector('[data-nt-ship-label]');
    var shipFill = note.querySelector('[data-nt-ship-fill]');
    function setShip(text, pct) {
      note.removeAttribute('hidden');
      if (shipLabel) shipLabel.textContent = text; else note.textContent = text;
      if (shipFill) shipFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    }

    /* Auto-detect: does the cart already have a Shopify free-shipping discount applied? */
    var shippingApplied = false;
    var apps = cart.cart_level_discount_applications || [];
    for (var k = 0; k < apps.length; k++) {
      var a = apps[k];
      if (a.target_type === 'shipping_line') { shippingApplied = true; break; }
      if (a.title && /shipping/i.test(a.title)) { shippingApplied = true; break; }
    }

    var rate = fxRate();
    if (shippingApplied) {
      setShip('✓ FREE SHIPPING APPLIED', 100);
    } else if (config.shipping_threshold > 0 && rate > 0) {
      var thresholdCents = Math.round(config.shipping_threshold * 100 * rate);
      if (cart.total_price >= thresholdCents) {
        setShip(config.shipping_note_above || 'Free Shipping Unlocked!', 100);
      } else {
        var remaining = thresholdCents - cart.total_price;
        var template = config.shipping_note_below || 'Add [remaining] more for free shipping.';
        setShip(template.replace(/\[remaining\]/g, formatMoney(remaining)), (cart.total_price * 100) / thresholdCents);
      }
    } else {
      /* No threshold set (or no usable FX rate) and no Shopify discount applied — hide the
         line entirely rather than show wrong-currency math. */
      note.setAttribute('hidden', '');
    }
  }

  function updateBadge(count) {
    var badges = document.querySelectorAll('[data-nt-cart-badge]');
    badges.forEach(function (b) {
      if (count > 0) {
        b.textContent = count;
        b.removeAttribute('hidden');
        b.style.display = '';
      } else {
        b.setAttribute('hidden', '');
        b.style.display = 'none';
      }
    });
    if (headerCount) headerCount.textContent = '(' + count + ')';
  }

  function applyCart(cart) {
    rebuildBody(cart);
    rebuildFoot(cart);
    updateBadge(hasCheckoutItems(cart) ? cart.item_count : 0);
  }

  /* ---------- Section Rendering API (preferred path) ----------
     Instead of duplicating Liquid logic in JS (which misses variant.compare_at_price),
     we ask Shopify to re-render the cart-drawer section server-side and swap the fresh
     HTML into place. Liquid already knows about MSRP savings, Shopify discounts, free
     shipping detection, upsells, everything. Single source of truth. */
  var SECTION_ID = 'nytron-cart-drawer';

  function refreshFromSectionHtml(html) {
    if (!html) return false;
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var newBody = temp.querySelector('[data-nt-cart-body]');
    if (newBody && body) body.innerHTML = newBody.innerHTML;

    var newFoot = temp.querySelector('[data-nt-cart-foot]');
    if (newFoot && foot) {
      foot.innerHTML = newFoot.innerHTML;
      if (newFoot.hasAttribute('hidden')) foot.setAttribute('hidden', '');
      else foot.removeAttribute('hidden');
    }

    /* The shipping bar lives at the top of the drawer, outside body and foot */
    var oldShip = drawer.querySelector('[data-nt-cart-ship]');
    var newShip = temp.querySelector('[data-nt-cart-ship]');
    if (oldShip && newShip) {
      oldShip.innerHTML = newShip.innerHTML;
      if (newShip.hasAttribute('hidden')) oldShip.setAttribute('hidden', '');
      else oldShip.removeAttribute('hidden');
    }

    var newCount = temp.querySelector('[data-nt-cart-count-text]');
    if (newCount && headerCount) headerCount.textContent = newCount.textContent;

    /* Parse "(N)" from the header count so badge stays accurate even when
       /cart/add.js response doesn't carry item_count. */
    if (newCount) {
      var m = newCount.textContent.match(/\d+/);
      if (m) updateBadge(parseInt(m[0], 10));
    }

    /* In a converted market the server-rendered ship bar is always hidden (Liquid cannot
       convert the USD threshold), so every fresh section swap needs a JS redraw. */
    if (CUR_MISMATCH) {
      (lastCart && typeof lastCart.total_price === 'number'
        ? Promise.resolve(lastCart)
        : fetchCart()
      ).then(updateShipBar).catch(function () {});
    }
    return true;
  }

  /* ---------- Network ---------- */
  function setLoading(on) { drawer.classList.toggle('is-loading', !!on); }

  /* Last cart we saw. Used only to decide whether the gift still needs adding, so a
     stale read can cost an extra reconcile but can never produce a wrong cart. */
  var lastCart = null;

  /* Shopify can occasionally return an HTML challenge/error page instead of JSON.
     Parse defensively so customers see a stable cart message, never WebKit's raw
     "The string did not match the expected pattern" exception. */
  function readJsonResponse(response, fallbackMessage) {
    return response.text().then(function (text) {
      var data = null;
      if (text) {
        try { data = JSON.parse(text); } catch (e) { data = null; }
      }
      if (!response.ok || data === null) {
        var err = new Error(fallbackMessage);
        if (data && typeof data.description === 'string' && data.description.trim()) {
          err.description = data.description;
        }
        err.status = response.status;
        /* HTML instead of JSON is Shopify's bot-protection challenge page (or an outage
           interstitial). Fetch can never pass a challenge — callers use this flag to fall
           back to a full-page submit where the customer can complete the verification. */
        err.nonJson = data === null;
        err.transient = data === null || response.status === 408 || response.status === 429 || response.status >= 500;
        throw err;
      }
      return data;
    });
  }

  function customerMessage(err, fallbackMessage) {
    if (err && typeof err.description === 'string' && err.description.trim()) {
      return err.description;
    }
    return fallbackMessage;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return readJsonResponse(r, 'Could not load your cart. Please try again.'); })
      .then(function (cart) { lastCart = cart; return cart; });
  }

  function cartVariantQty(cart, id) {
    var items = (cart && cart.items) || [];
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].variant_id || items[i].id) === Number(id)) total += items[i].quantity || 0;
    }
    return total;
  }

  function isTransientAddError(err) {
    return !!(err && (err.transient === true || (!err.status && err.name === 'TypeError')));
  }

  /* A transient response may hide a successful POST, so never retry blindly. Check
     the cart first; retry once only when the intended variant quantity did not move.
     Successful adds keep the normal one-request fast path. */
  function addWithRecovery(makeRequest, item) {
    var beforeQty = item && lastCart ? cartVariantQty(lastCart, item.id) : null;
    var expectedQty = beforeQty === null ? null : beforeQty + (Number(item.quantity) || 1);

    function perform() {
      return makeRequest()
        .then(function (r) { return readJsonResponse(r, 'Could not add item to cart. Please try again.'); })
        .then(function (data) {
          /* /cart/add.js is not a full cart. Invalidate the snapshot until the
             caller's normal background cart read replaces it. */
          lastCart = null;
          return data;
        });
    }

    return perform()
      .then(function (data) { return { data: data, cart: null }; })
      .catch(function (err) {
        if (!item || beforeQty === null || !isTransientAddError(err)) throw err;
        return new Promise(function (resolve) { setTimeout(resolve, 500); })
          .then(fetchCart)
          .then(function (cart) {
            if (cartVariantQty(cart, item.id) >= expectedQty) return { data: null, cart: cart };
            return perform().then(function (data) { return { data: data, cart: null }; });
          });
      });
  }

  /* ---------- Free gift reconciliation ----------
     One rule, enforced after every cart mutation: the gift is present exactly once
     whenever the cart holds something else, and absent otherwise. Absent-when-alone
     matters because a cart holding only the $0 line is a checkout-able $0 order.
     Returns the settled cart so callers can render from it. */
  function surveyGift(cart) {
    var out = { item: null, others: 0 };
    if (!cart || !cart.items) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftItem(cart.items[i])) out.item = cart.items[i];
      else out.others++;
    }
    return out;
  }

  /* The gift covers the kit, so its quantity mirrors the kit quantity: the sum of
     non-gift, non-upsell units in the cart. 2 kits -> 2 warranties; kit removed ->
     target 0 -> gift removed (a cart holding only the $0 line would be a
     checkout-able $0 order). */
  function giftTargetQty(cart) {
    var upsellIds = (config.upsells || []).map(function (u) { return Number(u.id); });
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftItem(it)) continue;
      if (isBonusItem(it) || isAddonItem(it)) continue;
      if (upsellIds.indexOf(Number(it.variant_id || it.id)) > -1) continue;
      total += it.quantity || 0;
    }
    return total;
  }

  /* The one write every reconcile goes through: several lines in a single atomic
     /cart/update.js call, with the drawer HTML in the same response. Returns the full
     cart (carrying .sections) and keeps lastCart current. */
  function postUpdates(updates) {
    return fetch(ROUTES.cart_update_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTION_ID })
    })
      .then(function (r) { return readJsonResponse(r, 'Could not update your cart. Please try again.'); })
      .then(function (cart) { lastCart = cart; return cart; });
  }

  /* Runs after EVERY cart mutation and on boot. The warranty mirrors the covered units and
     each bonus gift mirrors the kit; all corrections go out in ONE request (this used to be
     a change + re-read per line, five lines in a row, ~7s on a second Add to Cart).
     Only ever adjusts or removes EXISTING lines, never adds one, so a customer who removed
     a gift (or unticked the box) does not get it pushed back on them mid-session. */
  function tidyLines(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var updates = {}, n = 0;
    var g = GIFT_ID ? surveyGift(cart).item : null;
    if (g) {
      var target = giftTargetQty(cart);
      if (g.quantity !== target) { updates[g.key] = target; n++; }
    }
    if (BONUS_IDS.length) {
      var kq = kitQty(cart);
      for (var i = 0; i < BONUS_IDS.length; i++) {
        var line = bonusLine(cart, BONUS_IDS[i]);
        if (line && line.quantity !== kq) { updates[line.key] = kq; n++; }
      }
    }
    var al = PO_ADDON ? bonusLine(cart, PO_ADDON) : null;
    if (al) {
      var fq = firstKitQty(cart);
      if (al.quantity !== fq) { updates[al.key] = fq; n++; }
    }
    if (!n) return Promise.resolve(cart);
    return postUpdates(updates).catch(function () { return cart; });
  }

  /* Runs only on add-to-cart. Adds whatever is missing (the warranty when the tick box
     wants it, the bonus gifts when the kit is in) in ONE request. Swallow failures so a
     problem attaching a free extra can never block the customer's real add-to-cart. */
  function attachMissing(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var missing = [];
    if (giftWanted()) {
      var g = surveyGift(cart);
      if (!g.item && g.others > 0) missing.push({ id: GIFT_ID, quantity: 1 });
    }
    var kq = BONUS_IDS.length ? kitQty(cart) : 0;
    if (kq > 0) {
      for (var i = 0; i < BONUS_IDS.length; i++) {
        if (!bonusLine(cart, BONUS_IDS[i])) missing.push({ id: BONUS_IDS[i], quantity: kq, properties: { _nt_gift: '1' } });
      }
    }
    var fkq = PO_ADDON ? firstKitQty(cart) : 0;
    if (fkq > 0 && !bonusLine(cart, PO_ADDON)) missing.push({ id: PO_ADDON, quantity: fkq });
    if (!missing.length) return Promise.resolve(cart);
    /* Re-read rather than trusting the response: /cart/add.js returns the added
       items, not the whole cart. */
    return fetch(ROUTES.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: missing })
    }).then(function (r) { return readJsonResponse(r, 'Could not add the free gifts.'); })
      .then(fetchCart)
      .catch(function () { return cart; });
  }

  function settleAfterAdd(cart) {
    return attachMissing(cart).then(tidyLines);
  }

  /* Paint the drawer from a response that already carries its section HTML (every
     /cart/update.js write does); only fall back to a fresh render request when it doesn't. */
  function paintFrom(cart) {
    var html = cart && cart.sections && cart.sections[SECTION_ID];
    if (html && refreshFromSectionHtml(html)) {
      if (typeof cart.item_count === 'number') updateBadge(cart.item_count);
      return Promise.resolve(true);
    }
    return renderFromServer();
  }

  /* Re-render the drawer server-side and swap it in. Liquid is the only renderer
     that can see variant.compare_at_price, so it is the only one that computes the
     real "Original" and "You saved" (the kit's MSRP and the warranty's $97).
     /cart.js omits compare_at entirely, so rendering from JS understated the saving.
     Falls back to the JS render if the section request fails. */
  function renderFromServer() {
    return fetch('/?sections=' + SECTION_ID, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return readJsonResponse(r, 'Could not refresh your cart. Please try again.'); })
      .then(function (data) {
        if (data && data[SECTION_ID] && refreshFromSectionHtml(data[SECTION_ID])) return true;
        throw new Error('no section html');
      })
      .catch(function () {
        return fetchCart().then(function (cart) { applyCart(cart); return false; });
      });
  }

  /* Target lines by item.key, not positional index: keys survive re-renders and
     line removals, so a queued change can never hit the wrong row. The full-panel
     loading overlay is shown only for removals — for +/− taps it would sit over
     the buttons and eat every click made during the round-trip. */
  function lineByKey(cart, key) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) { if (items[i].key === key) return items[i]; }
    return null;
  }

  /* Units the gift should cover once this line becomes `quantity`: every non-gift,
     non-upsell unit in the cart, with the line being changed counted at its new value. */
  function unitsAfterChange(cart, key, quantity) {
    var upsellIds = (config.upsells || []).map(function (u) { return Number(u.id); });
    var items = (cart && cart.items) || [];
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (isGiftItem(it)) continue;
      if (isBonusItem(it) || isAddonItem(it)) continue;
      if (upsellIds.indexOf(Number(it.variant_id || it.id)) > -1) continue;
      total += (it.key === key) ? quantity : (it.quantity || 0);
    }
    return total;
  }

  /* One request per tap.
     This used to be three: change the kit, then a second write to correct the gift, then
     a re-render. Because the gift correction was a separate round trip, the drawer painted
     the in-between cart — so the warranty visibly trailed the kit by one step (kit 2 next
     to warranty 1), and a tap made during the ~3s window looked like it did nothing.
     /cart/update.js sets several lines at once, so the kit and the gift move together in a
     single atomic write and the section HTML that comes back is already the final state.
     Falls back to the old change-then-reconcile path when we have no cart to compute from. */
  /* The batched write for "this line becomes `quantity`": the line itself, the warranty
     re-counted, and every bonus gift mirrored to the kit, all in one update. Existing gift
     lines only, and never the line the customer is changing themselves, so removing a gift
     by hand sticks. */
  function updatesFor(cartNow, key, quantity) {
    var updates = {};
    updates[key] = quantity;
    /* Only ever move a gift line that already exists; adding one is attachMissing's job. */
    var giftLine = GIFT_ID ? surveyGift(cartNow).item : null;
    if (giftLine) {
      updates[giftLine.key] = unitsAfterChange(cartNow, key, quantity);
    }
    if (BONUS_IDS.length) {
      var kitAfter = 0;
      for (var ci = 0; ci < cartNow.items.length; ci++) {
        var cit = cartNow.items[ci];
        if (Number(cit.variant_id || cit.id) === BONUS_TRIGGER) kitAfter += (cit.key === key) ? quantity : (cit.quantity || 0);
      }
      for (var bj = 0; bj < BONUS_IDS.length; bj++) {
        var bl = bonusLine(cartNow, BONUS_IDS[bj]);
        if (bl && bl.key !== key && bl.quantity !== kitAfter) updates[bl.key] = kitAfter;
      }
    }
    var al = PO_ADDON ? bonusLine(cartNow, PO_ADDON) : null;
    if (al && al.key !== key) {
      var fAfter = firstKitQty(cartNow, key, quantity);
      if (al.quantity !== fAfter) updates[al.key] = fAfter;
    }
    return updates;
  }

  /* The cart line a drawer row points at. Shopify re-keys a line whenever its quantity
     changes (the gift discounts are part of the key), so a tap made while the previous
     change was in flight carries a dead key; fall back to the variant, when that is
     unambiguous. Without this the second of two spaced taps was silently dropped. */
  function resolveLine(cart, key) {
    var exact = lineByKey(cart, key);
    if (exact) return exact;
    var vid = String(key).split(':')[0];
    var items = (cart && cart.items) || [];
    var hit = null, n = 0;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id || items[i].id) === vid) { hit = items[i]; n++; }
    }
    return n === 1 ? hit : null;
  }

  function changeLine(key, quantity) {
    var overlay = quantity === 0;
    if (overlay) setLoading(true);

    var cartNow = lastCart;
    var line = cartNow ? resolveLine(cartNow, key) : null;
    if (!line) {
      return fetchCart().then(function (fresh) {
        var l = resolveLine(fresh, key);
        return l ? sendLineChange(fresh, l, quantity, overlay) : changeLineFallback(key, quantity, overlay);
      });
    }
    return sendLineChange(cartNow, line, quantity, overlay);
  }

  function sendLineChange(cartNow, line, quantity, overlay) {
    return postUpdates(updatesFor(cartNow, line.key, quantity))
      .then(function (cart) {
        var html = cart && cart.sections && cart.sections[SECTION_ID];
        if (html && refreshFromSectionHtml(html)) {
          if (typeof cart.item_count === 'number') updateBadge(cart.item_count);
          return;
        }
        applyCart(cart);
      })
      .catch(function () { return fetchCart().then(applyCart); })
      .finally(function () { if (overlay) setLoading(false); });
  }

  function changeLineFallback(key, quantity, overlay) {
    return fetch(ROUTES.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION_ID })
    })
      .then(function (r) { return readJsonResponse(r, 'Could not update your cart. Please try again.'); })
      .then(tidyLines)
      .then(function (data) {
        var html = data && data.sections && data.sections[SECTION_ID];
        if (html && refreshFromSectionHtml(html)) {
          if (typeof data.item_count === 'number') updateBadge(data.item_count);
          return;
        }
        return renderFromServer();
      })
      .catch(function () { return fetchCart().then(applyCart); })
      .finally(function () { if (overlay) setLoading(false); });
  }

  /* Rapid +/− clicks: show the new number immediately, then send ONE request with
     the final value once the clicks stop. Requests are chained so two changes can
     never race each other (three fast "+" used to send the same stale target three
     times and land on 2 instead of 4). */
  var qtyTimers = {};
  var changeChain = Promise.resolve();
  function enqueueChange(key, quantity) {
    changeChain = changeChain.then(function () { return changeLine(key, quantity); });
  }
  function debounceChange(key, quantity) {
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      enqueueChange(key, quantity);
    }, 300);
  }

  function addVariant(id, quantity) {
    setLoading(true);
    var item = { id: Number(id), quantity: quantity || 1 };
    function makeRequest() {
      var fd = new FormData();
      fd.append('id', item.id);
      fd.append('quantity', item.quantity);
      fd.append('sections', SECTION_ID);
      return fetch(ROUTES.cart_add_url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: fd
      });
    }
    return addWithRecovery(makeRequest, item)
      .then(function (result) {
        if (result.cart) {
          return settleAfterAdd(result.cart).then(paintFrom).then(function () { openDrawer(); });
        }
        var data = result.data;
        /* With a gift configured we have to read the cart back to reconcile it, so the
           Section Rendering shortcut only helps when the feature is switched off. */
        if (!GIFT_ID) {
          var html = data && data.sections && data.sections[SECTION_ID];
          if (html && refreshFromSectionHtml(html)) {
            openDrawer();
            return;
          }
        }
        /* Fallback if Section Rendering API didn't return HTML for some reason */
        return fetchCart().then(settleAfterAdd).then(paintFrom).then(function () { openDrawer(); });
      })
      .catch(function (err) {
        if (nativeAddFallback(err, item)) return;
        var msg = customerMessage(err, 'Could not add item to cart. Please try again.');
        try { alert(msg); } catch (e) {}
      })
      .finally(function () { setLoading(false); });
  }

  /* Bot challenge escape hatch: the fetch add got an HTML challenge page, which no
     retry can pass. Re-submit as a plain form POST so the browser navigates, the
     customer completes the "are you human" check once, and Shopify finishes the add
     and lands them on /cart. Losing the drawer beats losing the sale. */
  function nativeAddFallback(err, item) {
    if (!err || !err.nonJson || !item || !item.id) return false;
    try {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = ROUTES.cart_add_url;
      var field = function (name, value) {
        var el = document.createElement('input');
        el.type = 'hidden'; el.name = name; el.value = value;
        f.appendChild(el);
      };
      field('items[0][id]', item.id);
      field('items[0][quantity]', item.quantity || 1);
      if (PO_ID && Number(item.id) === PO_ID) {
        field('items[0][properties][Pre-order]', poLabel());
        if (firstChosen()) { field('items[1][id]', PO_ADDON); field('items[1][quantity]', item.quantity || 1); }
      }
      document.body.appendChild(f);
      f.submit();
      return true;
    } catch (e) { return false; }
  }

  /* A plain kit form carries nothing but id + quantity. That is the shape we can safely
     re-express as JSON so the gift rides along in the SAME request. Anything richer
     (line item properties, selling plans) takes the original FormData path untouched.
     Shopify's {% form 'product' %} adds form_type, utf8, product-id and section-id on its
     own; they carry nothing for the cart, so they must not push the buy box off this path
     (they did from Sep 10: 7 chained requests, ~4.4s before the drawer opened). */
  var FORM_NOISE = { form_type: 1, utf8: 1, 'product-id': 1, 'section-id': 1 };
  function simpleAddItem(form) {
    var fd = new FormData(form);
    var id = null, quantity = 1, keys = 0;
    fd.forEach(function (value, name) {
      keys++;
      if (name === 'id') id = value;
      else if (name === 'quantity') quantity = parseInt(value, 10) || 1;
      else if (FORM_NOISE[name]) return;
      else keys += 100; /* an unexpected field: disqualify */
    });
    if (!id || keys > 100) return null;
    return { id: Number(id), quantity: quantity };
  }

  /* Add to Cart when the kit is already in the cart (a second tap, a second kit): raise
     that line and move the warranty and gifts with it in ONE /cart/update.js write, whose
     response already carries the drawer HTML. The /cart/add route needed an add, a re-read,
     then a reconcile, three round trips at best. Only taken when every gift line the add
     would otherwise attach is already there; anything else returns null and goes the normal
     way. Returns a promise or null. */
  function bumpExistingLine(item) {
    var cart = lastCart;
    if (!item || !cart || !cart.items) return null;
    if (PO_ID && Number(item.id) === PO_ID) return null; /* pre-order: normal add carries the property */
    var line = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (Number(it.variant_id || it.id) !== item.id || isGiftItem(it) || isBonusItem(it)) continue;
      if (it.selling_plan_allocation || (it.properties && Object.keys(it.properties).length)) continue;
      line = it;
      break;
    }
    if (!line) return null;
    if (giftWanted() && !surveyGift(cart).item) return null;
    if (item.id === BONUS_TRIGGER) {
      for (var b = 0; b < BONUS_IDS.length; b++) { if (!bonusLine(cart, BONUS_IDS[b])) return null; }
    }
    var expected = cartVariantQty(cart, item.id) + item.quantity;
    setLoading(true);
    return postUpdates(updatesFor(cart, line.key, line.quantity + item.quantity))
      .then(function (updated) {
        /* Check by variant, not line key: Shopify re-keys the kit line whenever its quantity
           changes (the gift discounts are part of the key). /cart/update.js also caps at stock
           silently; a short count lets the normal add report it instead. */
        if (cartVariantQty(updated, item.id) < expected) throw new Error('short');
        return paintFrom(updated).then(function () { openDrawer(); });
      })
      .finally(function () { setLoading(false); });
  }

  function addFromForm(form) {
    var item = simpleAddItem(form);
    var was = item && lastCart ? cartVariantQty(lastCart, item.id) : -1;
    var bumped = bumpExistingLine(item);
    if (!bumped) return addFromFormRequest(form, item);
    return bumped.catch(function (err) {
      try { console.warn('[nt-cart] bump fell back:', err && (err.stack || err.message)); } catch (e) {}
      /* The write may have landed before the error. Never add twice: re-read, and only fall
         through to a normal add when the kit did not move. */
      return fetchCart().then(function (cart) {
        if (cartVariantQty(cart, item.id) > was) {
          return tidyLines(cart).then(paintFrom).then(function () { openDrawer(); });
        }
        return addFromFormRequest(form, item);
      });
    });
  }

  function addFromFormRequest(form, item) {
    /* One round trip instead of five. Adding the kit used to be: add kit, re-read cart,
       add gift, re-read cart, re-render section — about 2.9s of chained requests before
       the drawer opened. When we already know the cart has no gift line, both go in the
       same call and the section HTML that comes back is already correct. */
    var giftRides = !!(item && GIFT_ID && giftWanted() && lastCart && !(lastCart.items || []).some(isGiftItem));
    setLoading(true);

    var makeRequest;
    if (item) {
      withPreorder(item);
      var items = giftRides ? [item, { id: GIFT_ID, quantity: 1 }] : [item];
      /* Bonus gifts ride the same request when the kit itself is being added and they are
         not in the cart yet; attachMissing in settleAfterAdd covers every other route. */
      if (BONUS_IDS.length && Number(item.id) === BONUS_TRIGGER) {
        for (var bx = 0; bx < BONUS_IDS.length; bx++) {
          if (!lastCart || !bonusLine(lastCart, BONUS_IDS[bx])) items.push({ id: BONUS_IDS[bx], quantity: 1, properties: { _nt_gift: '1' } });
        }
      }
      if (firstChosen() && Number(item.id) === PO_ID && (!lastCart || !bonusLine(lastCart, PO_ADDON))) {
        items.push({ id: PO_ADDON, quantity: item.quantity });
      }
      var requestBody = JSON.stringify({ items: items, sections: SECTION_ID });
      makeRequest = function () {
        return fetch(ROUTES.cart_add_url + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: requestBody
        });
      };
    } else {
      makeRequest = function () {
        var fd = new FormData(form);
        fd.append('sections', SECTION_ID);
        return fetch(ROUTES.cart_add_url + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd
        });
      };
    }

    return addWithRecovery(makeRequest, item)
      .then(function (result) {
        if (result.cart) {
          return settleAfterAdd(result.cart).then(paintFrom).then(function () { openDrawer(); });
        }
        var data = result.data;
        var html = data && data.sections && data.sections[SECTION_ID];
        /* Paint from the response when it already reflects the final cart: either there is
           no gift feature, or the gift went in on this same call. */
        if ((!GIFT_ID || giftRides) && html && refreshFromSectionHtml(html)) {
          openDrawer();
          /* Quantities above one, or a gift the cached cart did not know about, are
             settled quietly afterwards — the shopper is already looking at the drawer. */
          fetchCart().then(function (cart) {
            return settleAfterAdd(cart).then(function (settled) {
              /* settleAfterAdd hands back the same object when nothing needed fixing. */
              if (settled !== cart) return paintFrom(settled);
            });
          }).catch(function () {});
          return;
        }
        return fetchCart().then(settleAfterAdd).then(paintFrom).then(function () { openDrawer(); });
      })
      .catch(function (err) {
        if (nativeAddFallback(err, item || simpleAddItem(form))) return;
        if (err && err.nonJson && form && !form.dataset.ntNativeRetry) {
          /* Rich form (properties/selling plan): replay it whole as a real page submit. */
          form.dataset.ntNativeRetry = '1';
          form.submit();
          return;
        }
        var msg = customerMessage(err, 'Could not add item to cart. Please try again.');
        try { alert(msg); } catch (e) {}
      })
      .finally(function () { setLoading(false); });
  }

  /* ---------- Delegated events inside the drawer ---------- */
  drawer.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-nt-qty-dec]');
    var inc = e.target.closest('[data-nt-qty-inc]');
    var rm = e.target.closest('[data-nt-remove]');
    var upsell = e.target.closest('[data-nt-upsell-add]');

    if (dec || inc || rm) {
      var li = e.target.closest('[data-nt-line]');
      if (!li) return;
      var key = li.getAttribute('data-nt-line-key');
      if (!key) return;
      var valEl = li.querySelector('[data-nt-qty-val]');
      var current = parseInt((valEl || {}).textContent || '0', 10) || 0;
      if (rm) {
        clearTimeout(qtyTimers[key]);
        delete qtyTimers[key];
        enqueueChange(key, 0);
        return;
      }
      var next = dec ? Math.max(0, current - 1) : current + 1;
      if (valEl) valEl.textContent = next;
      debounceChange(key, next);
    } else if (upsell) {
      var id = upsell.getAttribute('data-nt-upsell-add');
      if (id) {
        upsell.disabled = true;
        addVariant(id, 1).finally(function () { upsell.disabled = false; });
      }
    }
  });

  /* ---------- Form interception (global) ----------
     Any <form action="/cart/add" ...> on the page is hijacked.
     This wires up Order Kit forms in hero / final-cta / buy-box automatically. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\b|\/?$)/.test(action)) return;
    if (form.hasAttribute('data-nt-cart-skip')) return;
    e.preventDefault();
    /* Run before a form-level <product-form> handler and stop it from issuing a
       second /cart/add request for the same customer click. */
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) btn.disabled = true;
    addFromForm(form).finally(function () { if (btn) btn.disabled = false; });
  }, true);

  /* Signal readiness + process any Add-to-Cart submits captured by the early inline guard
     (in nytron-cart-drawer.liquid) before this deferred script attached its handler. */
  window.__ntCartReady = true;
  if (window.__ntCartPending && window.__ntCartPending.length) {
    window.__ntCartPending.splice(0).forEach(function (form) { addFromForm(form); });
  }

  /* ---------- The standalone /cart page ----------
     Everywhere else the drawer routes changes through this module, so the gift always
     follows the kit. /cart is Dawn's own template: its quantity control posts to
     /cart/change and re-renders its section without telling us, which left 3 kits sitting
     next to 2 warranties.

     Scoped to /cart on purpose. An earlier attempt wrapped window.fetch globally to catch
     any cart write, which also caught this module's OWN gift add and raced a second
     reconcile against settleAfterAdd. On iOS that race broke add-to-cart outright. Nothing
     here runs on a product page. */
  (function watchCartPage() {
    if (!GIFT_ID) return;
    if (!/^\/cart(\/|$)/.test(location.pathname)) return;
    var timer = null;
    function reconcileSoon() {
      clearTimeout(timer);
      /* Let Dawn finish its own change + section re-render before we look. */
      timer = setTimeout(function () {
        fetchCart()
          .then(function (cart) {
            return tidyLines(cart).then(function (settled) {
              updateBadge(settled.item_count);
              /* tidyLines hands back the same object when nothing needed fixing. */
              if (settled !== cart) { location.reload(); }
            });
          })
          .catch(function () {});
      }, 900);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.cart-item [name="plus"], .cart-item [name="minus"], cart-remove-button')) reconcileSoon();
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'updates[]') reconcileSoon();
    });
  })();

  /* ---------- Boot: sync badge with real cart on first load ----------
     Tidy only. A restored cart that never had the gift is a cart the customer either
     built before this shipped or actively unticked, and neither is ours to override. */
  fetchCart()
    .then(function (cart) {
      updateBadge(cart.item_count);
      /* Converted market: the Liquid-rendered ship bar starts hidden; draw it now with the
         threshold converted into the visitor's currency. */
      if (CUR_MISMATCH) updateShipBar(cart);
      if (!GIFT_ID) return null;
      return tidyLines(cart).then(function (settled) {
        if (settled && settled.item_count !== cart.item_count) {
          applyCart(settled);
          /* Dawn's standalone /cart markup was rendered before the orphan gift was
             removed. Reload once so its own item list and checkout button also clear. */
          if (/^\/cart(\/|$)/.test(location.pathname)) location.reload();
        }
      });
    })
    .catch(function () {});
})();
